import { withAuthStatus } from './withAuthStatus'

const AuthStatus = ({ authStatus, userId, children }) =>
  children(authStatus, userId)

export default withAuthStatus(AuthStatus)



// WEBPACK FOOTER //
// ./src/modules/auth/AuthStatus.js